"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionsWrapper = void 0;

var _clsx2 = _interopRequireDefault(require("clsx"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var classes = {
  "root": "actions-wrapper-module__root___wgZjU",
  "center": "actions-wrapper-module__center___2G52Z",
  "alignRight": "actions-wrapper-module__alignRight___2KJ8l",
  "spread": "actions-wrapper-module__spread___3rYfm"
};

var ActionsWrapper = function ActionsWrapper(_ref) {
  var _clsx;

  var children = _ref.children,
      className = _ref.className,
      align = _ref.align,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      spacing = _ref.spacing,
      center = _ref.center;
  // @ts-ignore
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    style: _objectSpread({
      '--actions-wrapper-spacing': spacing
    }, style),
    className: (0, _clsx2.default)(classes.root, className, (_clsx = {}, _defineProperty(_clsx, classes.alignRight, align === 'right'), _defineProperty(_clsx, classes.spread, align === 'spread'), _defineProperty(_clsx, classes.center, center), _clsx)),
    children: children
  });
};

exports.ActionsWrapper = ActionsWrapper;